import toast from "react-hot-toast";
import {
  ADD_ADDRESS,
  ADD_ADDRESS_FAIL,
  ADD_ADDRESS_SUCCESS,
  GET_ADDRESS_LIST,
  GET_ADDRESS_LIST_FAIL,
  GET_ADDRESS_LIST_SUCCESS,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_FAIL,
  UPDATE_ADDRESS_MULTIPLE,
  UPDATE_ADDRESS_MULTIPLE_FAIL,
  UPDATE_ADDRESS_MULTIPLE_SUCCESS,
  UPDATE_ADDRESS_SUCCESS,
  GET_VIRTUAL_LOCKER,
  GET_VIRTUAL_LOCKER_FAIL,
  GET_VIRTUAL_LOCKER_SUCCESS,
  ADD_VIRTUAL_LOCKER,
  ADD_VIRTUAL_LOCKER_FAIL,
  ADD_VIRTUAL_LOCKER_SUCCESS,
  DELETE_ADDRESS,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAIL,
} from "../actions/AddressActions";
import {
  SET_DEFAULT_ADDRESS,
  SET_DEFAULT_ADDRESS_FAIL,
  SET_DEFAULT_ADDRESS_SUCCESS,
} from "../actions/AuthActions";

function isLockerExpiryToastMessage(message) {
  const text = String(message ?? "").toLowerCase();
  return text.includes("locker has expired") || text.includes("locker expired");
}

const initialState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  addressList: [],
  virtualAddress: [],
  virtualAccept: [],
};
const addressReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_ADDRESS_MULTIPLE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case UPDATE_ADDRESS_MULTIPLE_SUCCESS: {
      return {
        ...state,
        addressList: payload.data,
        isLoading: false,
      };
    }

    case UPDATE_ADDRESS_MULTIPLE_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case GET_ADDRESS_LIST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case GET_ADDRESS_LIST_SUCCESS: {
      return {
        ...state,
        addressList: payload.data,
        isLoading: false,
      };
    }

    case GET_ADDRESS_LIST_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case ADD_ADDRESS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ADD_ADDRESS_SUCCESS: {
      toast.success("Address added successfully");
      return {
        ...state,
        addressList: [...state.addressList, payload.data],
        isLoading: false,
      };
    }

    case ADD_ADDRESS_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case UPDATE_ADDRESS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case UPDATE_ADDRESS_SUCCESS: {
      toast.success("Address updated successfully");
      return {
        ...state,
        addressList: state.addressList.map((address) => {
          if (address.id === payload.data.id) {
            return payload.data;
          }
          return address;
        }),
        isLoading: false,
      };
    }

    case UPDATE_ADDRESS_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }
    case DELETE_ADDRESS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case DELETE_ADDRESS_SUCCESS: {
      toast.success("Address delete successfully");
      return {
        ...state,
        addressList: state.addressList.map((address) => {
          if (address.id === payload.data.id) {
            return payload.data;
          }
          return address;
        }),
        isLoading: false,
      };
    }

    case DELETE_ADDRESS_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case SET_DEFAULT_ADDRESS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SET_DEFAULT_ADDRESS_SUCCESS: {
      toast.success("Default Address Changed successfully");
      return {
        ...state,
        addressList: state.addressList.map((address) => {
          if (address.id === payload.data.id) {
            return payload.data;
          }
          return {
            ...address,
            is_default: false,
          };
        }),
        isLoading: false,
      };
    }

    case SET_DEFAULT_ADDRESS_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case ADD_VIRTUAL_LOCKER: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ADD_VIRTUAL_LOCKER_SUCCESS: {
      return {
        ...state,
        virtualAddress: payload?.data,
        isLoading: false,
      };
    }

    case ADD_VIRTUAL_LOCKER_FAIL: {
      const message =
        payload?.error?.data?.message || payload?.error?.message;
      if (message && !isLockerExpiryToastMessage(message)) {
        toast.error(message);
      }
      return {
        ...state,
        isLoading: false,
      };
    }
    case GET_VIRTUAL_LOCKER: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case GET_VIRTUAL_LOCKER_SUCCESS: {
      toast.success("Address Accept successfully");

      return {
        ...state,
        virtualAccept: payload.data,
        isLoading: false,
      };
    }

    case GET_VIRTUAL_LOCKER_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return { ...state };
    }
  }
};
export default addressReducer;
